export default "/images/tutorial_d.webp"